import React, { useEffect, useId, useRef, useState } from 'react';
import { InlineError } from '../InlineError/InlineError.js';
const styles = {"codeInput":"CodeInput-module__codeInput__s3acL","label":"CodeInput-module__label__V9ZmM","field":"CodeInput-module__field__YYXwX","cells":"CodeInput-module__cells__X9DZk","cell":"CodeInput-module__cell__n9ZgW","input":"CodeInput-module__input__jc7rl"};
const NON_DIGITS = /\D/g;
/**
 * The one-time code (Foundations · CodeInput board, frames D1–D4): one real input, so paste and autofill work, drawn
 * over decorative cells. Backspace on an empty position moves back natively. Focused on mount.
 */
export function CodeInput({ label, value, onChange, onComplete, error, errorRevision, disabled, length = 6 }) {
    const inputId = useId();
    const errorId = `${inputId}-error`;
    const inputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const hasError = error !== undefined && error !== '';
    const isDisabled = disabled === true;
    const activeIndex = Math.min(value.length, length - 1);
    const cellIndexes = Array.from({ length }, (_unused, index) => index);
    useEffect(() => {
        inputRef.current?.focus();
    }, []);
    useEffect(() => {
        if (error !== undefined && error !== '') {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [error, errorRevision]);
    function acceptText(text) {
        const digits = text.replace(NON_DIGITS, '').slice(0, length);
        onChange(digits);
        if (digits.length === length && digits !== value) {
            onComplete(digits);
        }
    }
    function handlePaste(event) {
        event.preventDefault();
        acceptText(event.clipboardData.getData('text'));
    }
    function findCellState(index) {
        let cellState;
        if (isFocused && !isDisabled && index === activeIndex) {
            cellState = 'active';
        }
        return cellState;
    }
    return (React.createElement("div", { className: styles.codeInput, "data-error": hasError ? 'true' : undefined, "data-disabled": isDisabled ? 'true' : undefined },
        React.createElement("label", { className: styles.label, htmlFor: inputId }, label),
        React.createElement("div", { className: styles.field },
            React.createElement("div", { className: styles.cells, "aria-hidden": "true" }, cellIndexes.map(index => (React.createElement("span", { key: index, className: styles.cell, "data-state": findCellState(index) }, value.charAt(index))))),
            React.createElement("input", { ref: inputRef, id: inputId, className: styles.input, type: "text", inputMode: "numeric", autoComplete: "one-time-code", maxLength: length, value: value, disabled: isDisabled, "aria-invalid": hasError ? 'true' : undefined, "aria-describedby": hasError ? errorId : undefined, onChange: event => acceptText(event.target.value), onPaste: handlePaste, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false) })),
        hasError && React.createElement(InlineError, { id: errorId, message: error })));
}
//# sourceMappingURL=CodeInput.js.map